import { createAuthClient } from "better-auth/react";
import { passkeyClient } from "@better-auth/passkey/client";

export const authClient = createAuthClient({
  // In Next.js, we can check window.location to determine the environment
  // Or just omit baseURL since it defaults to the current domain
  // baseURL: undefined means it will use the same domain as the current page
  plugins: [
    passkeyClient(),
  ],
})
